import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_PRIORITIES } from "../../../utils/constants";
import { PriorityInterface } from "../../../models/TicketModule/Priority";
import priorityService from "../../../services/ticketService/priorityService";

interface AddPriorityContext {
  previousPriorities: PriorityInterface[];
}

const useAddPriorities = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    PriorityInterface,
    Error,
    PriorityInterface,
    AddPriorityContext
  >({
    mutationFn: priorityService.Save,

    onMutate: () => {
      const previousPriorities =
        queryClient.getQueryData<PriorityInterface[]>([
          CACHE_KEY_PRIORITIES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousPriorities };
    },

    onSuccess: (savedPriorities, newPriority) => {
      queryClient.setQueryData<PriorityInterface[]>(
        [
          CACHE_KEY_PRIORITIES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (priorities) =>
          priorities ? [savedPriorities, ...priorities] : [savedPriorities]
      );
    },

    onError: (error, newPriority, context) => {
      if (!context) return;

      queryClient.setQueryData<PriorityInterface[]>(
        [
          CACHE_KEY_PRIORITIES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousPriorities
      );
    },
  });
};

export default useAddPriorities;
